/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'react-toastify/dist/ReactToastify.css';

import CN from 'classnames';
import { Button, Input } from 'components/atoms';
import { Header } from 'components/common/Header';
import { SideBar } from 'components/common/SideBar';
import { Modal } from 'components/molecules/Modal';
import { useGenerateTickets, useGetAllTickets, useGetVerifyUserToken } from 'framework/api/methods';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import {
  setGenerateTokenModalHide,
  setTicketList,
  setUserDetails,
} from 'store/reducers/user/userSlice';

export interface MainLayoutProps {
  [x: string]: any;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }: MainLayoutProps) => {
  const navigate = useNavigate();
  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const { userDetails }: any = useSelector<any>((state) => state.user);
  const { isGenerateTokenModalOpen }: any = useSelector<any>((state) => state.user);
  const urlLocation = useLocation();
  const dispatch = useDispatch();
  const firstRoute = urlLocation.pathname.split('/')[1];
  const token = localStorage.getItem('token');

  const [ticketName, setTicketName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [ticketId, setTicketId] = useState('');

  const onSuccessVerifyToken = (data: any) => {
    dispatch(setUserDetails({ name: data?.enterpriseData, status: data?.userStatus }));
  };

  const onErrorVerifyToken = (data: any) => {
    notify('Session expired.', 'error');
    setTimeout(() => {
      navigate('/auth/login');
      localStorage.clear();
    }, 2000);
  };

  const onSuccessGetAllToken = (data: any) => {
    dispatch(setTicketList(data.tickets || []));
  };

  const onErrorGetAllToken = (data: any) => {
    notify('Session expired.', 'error');
    setTimeout(() => {
      navigate('/auth/login');
      localStorage.clear();
    }, 2000);
  };

  /** Get all cards API */
  const { refetch: getVerifyToken } = useGetVerifyUserToken(
    onSuccessVerifyToken,
    onErrorVerifyToken,
    false,
  );

  const { refetch: getAllTickets } = useGetAllTickets(onSuccessGetAllToken, onErrorGetAllToken);

  useEffect(() => {
    if (token) {
      getVerifyToken();
      getAllTickets();
    }
  }, [token]);

  useEffect(() => {
    if (urlLocation.pathname === '/tickets') {
      getAllTickets();
    }
  }, [urlLocation]);

  const { mutate: generateTicketsMutate, isLoading: generateTicketsIsLoading } =
    useGenerateTickets();

  const generateTickets = () => {
    generateTicketsMutate(
      {
        ticketName,
        phoneNumber,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          getAllTickets();
          setTicketId(successData?.ticket?.ticket_id);
          notify(successData?.message || 'New Ticket generated', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const initialObj = [
    {
      mainMenuId: 0,
      mainMenuItemKey: Math.random(),
      name: 'Dashboard',
      url: '/',
      icon: <i className="ri-line-chart-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 2,
      mainMenuItemKey: Math.random(),
      name: 'Spotlight',
      url: '/spotlight',
      icon: <i className="ri-video-on-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 3,
      mainMenuItemKey: Math.random(),
      name: 'Ticket',
      url: '/tickets',
      icon: <i className="ri-coupon-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
  ];

  return (
    <div className="w-full h-screen">
      {/* <SideBar firstRoute={firstRoute} menuItemList={initialObj} userDetails={userDetails} /> */}

      <div
        className={CN(
          'main-layout__content z-10 fixed h-full left-0 w-full bg-[#f4f4f4]', // F9FAFB
        )}
      >
        <Header userDetails={userDetails} firstRoute={firstRoute} menuItemList={initialObj} />
        <div className="h-[calc(100%-70px)] w-full">
          {children}{' '}
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            className="toast-container"
          />
          <Modal isActive={isGenerateTokenModalOpen} isHeaderShow={false} isFooterShow={false}>
            <div className="flex flex-col w-full">
              <div className="w-full flex justify-end items-end px-2 mt-2">
                <i
                  className="ri-close-line text-base text-[white] bg-[#7B1B67] rounded-full w-[20px] h-[20px] justify-center items-center flex"
                  onClick={() => {
                    dispatch(setGenerateTokenModalHide());
                    getAllTickets();
                    setTicketId('');
                    setTicketName('');
                    setPhoneNumber('');
                  }}
                />
              </div>
              <div className="flex flex-col justify-center items-center ">
                <div className="pt-1 text-2xl text-[#7B1B67] pb-3">
                  {!ticketId ? `Generate Ticket` : `Ticket ID`}
                </div>
                {ticketId && (
                  <div className="pt-1 text-2xl text-[#63717A] pb-8 font-black">
                    {ticketId || `- - - -`}
                  </div>
                )}
                {!ticketId && (
                  <div className="w-full flex justify-center items-center flex-col gap-y-5">
                    <Input
                      placeholder="Enter name"
                      className="!w-2/3"
                      value={ticketName}
                      isDisabled={!!ticketId}
                      inputClassName="!text-center"
                      onChange={(e) => {
                        setTicketName(e.target.value);
                      }}
                    />

                    <div className="!w-2/3 flex flex-col justify-center items-center bg">
                      <Input
                        placeholder="Enter Phone Number"
                        className="!w-full"
                        value={phoneNumber}
                        isDisabled={!!ticketId}
                        inputClassName="!text-center"
                        onChange={(e) => {
                          setPhoneNumber(e.target.value);
                        }}
                      />
                      <div className="text-sm text-[#CCCCCC]">(optional)</div>
                    </div>
                  </div>
                )}
                {!ticketId && (
                  <Button
                    size="sm"
                    className="mt-3 mb-6"
                    disabled={!ticketName || !!ticketId}
                    isLoading={generateTicketsIsLoading}
                    onClick={() => {
                      generateTickets();
                    }}
                  >
                    Generate
                  </Button>
                )}
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
